const meta = {
  'apply-functions': 'Apply functions',
  'promql-custom-functions': 'Custom functions',
  'experimental-functions': 'Experimental functions',
};

export default meta;
